import { render, staticRenderFns } from "./CategoryNav.vue?vue&type=template&id=0ae875c8"
import script from "./CategoryNav.vue?vue&type=script&lang=js"
export * from "./CategoryNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports